import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const changeAssayStatus = (assayId, status) => {
  const body = JSON.stringify({ id: assayId, active: status })

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body
  };

  return postToApi('v1/api/assays/set_active', fetchOptions)
}

export default changeAssayStatus;
